import { render, staticRenderFns } from "./SBArtistListCategoryIcon.html?vue&type=template&id=3f9582a2&scoped=true&"
import script from "./SBArtistListCategoryIcon.ts?vue&type=script&lang=ts&"
export * from "./SBArtistListCategoryIcon.ts?vue&type=script&lang=ts&"
import style0 from "./SBArtistListCategoryIcon.css?vue&type=style&index=0&id=3f9582a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9582a2",
  null
  
)

export default component.exports